import { ReactElement } from "react";
import { Button } from "@twilio-paste/core/button";
import { ButtonGroup as PasteButtonGroup } from "@twilio-paste/core/button-group";

import {
  ButtonGroupBlock,
  ButtonValues,
  WiseOwlActionType,
  trackingDetails,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

import { useWiseOwlContext } from "../../../hooks";

interface ButtonGroupRendererProps {
  block: ButtonGroupBlock;
}

const ButtonGroup = ({ block }: ButtonGroupRendererProps): ReactElement => {
  const {
    handlers: { handleRedirectAction, handleTrackEvent },
  } = useWiseOwlContext();

  const handleButtonTrackingEvent = (buttonText: string): void => {
    if (handleTrackEvent) {
      handleTrackEvent(
        trackingDetails.wiseOwlButtonActionClicked(buttonText),
        {}
      );
    }
  };

  const handleButtonAction = (button: ButtonValues) => {
    const { action } = button;
    if (action.type === WiseOwlActionType.Redirect) {
      if (handleRedirectAction) {
        handleRedirectAction(action.values.redirectUrl);
      }
    }
    handleButtonTrackingEvent(button.text);
  };

  return (
    <PasteButtonGroup>
      {block.values.buttons.map((button) => (
        <Button
          variant="secondary"
          size="rounded_small"
          onClick={() => handleButtonAction(button)}
        >
          {button.text}
        </Button>
      ))}
    </PasteButtonGroup>
  );
};

export default ButtonGroup;
